/** The one empty state for a feature whose module this server does not run (see server.ts). */
import type { ReactNode } from 'react';
import { EmptyState } from '@orgus/ui';
import { absentModuleCopy, moduleAbsent, useServer } from './server.ts';
import type { AbsentModule } from './server.ts';

export function ModuleAbsent({ icon, size, className, ...m }: AbsentModule & { icon?: ReactNode; size?: 'page' | 'compact'; className?: string }) {
  const { kind } = useServer();
  const copy = absentModuleCopy(kind, m);
  return <EmptyState title={copy.title} description={copy.description} {...(icon ? { icon } : {})} {...(size ? { size } : {})} {...(className ? { className } : {})} />;
}

export interface WhenRunsProps extends Omit<AbsentModule, 'hub'> {
  /** A module name ('finance') or a route ('/api/policy/versions'). */
  module: string;
  icon?: ReactNode;
  size?: 'page' | 'compact';
  className?: string;
  children: ReactNode;
}

/**
 * Its children where the server runs `module`; on Orgus Cloud without it, the honest empty state
 * instead, so nothing under it asks for routes that are not there. A hub always shows the children.
 */
export function WhenRuns({ module, children, icon, size, className, ...m }: WhenRunsProps) {
  const info = useServer();
  if (!moduleAbsent(info, module)) return <>{children}</>;
  const copy = absentModuleCopy('cloud', { ...m, hub: { title: '', description: '' } });
  return <EmptyState title={copy.title} description={copy.description} {...(icon ? { icon } : {})} {...(size ? { size } : {})} {...(className ? { className } : {})} />;
}
